import React, { ReactElement } from 'react';
import Logo from 'assets/svgs/logos/logo-half-blue-white.svg';
import bgReservation from 'assets/images/bg-reservation.jpg';
import DateBox from 'components/date-box/date-box';
import { useTranslate } from 'hooks/translate';
import './styles.scss';

export interface ReservationCardProps {
  reservation: Reservation;
  parks?: Park[];
  buttonText: string;
  buttonAction: () => void;
  href: string;
}

const ReservationCard = ({
  reservation,
  parks,
  buttonText,
  buttonAction,
  href,
}: ReservationCardProps): ReactElement => {
  const { t } = useTranslate();
  const park = parks?.filter((park) => park.id === reservation.parkId)[0];
  const min = reservation.startDate;
  const max = reservation.endDate;
  const sortedDates = [min, max];

  return (
    <div
      className='reservation-card'
      style={{ backgroundImage: `url(${bgReservation})` }}
    >
      <div className='card-container'>
        <div className='details'>
          <div className='logo-wrapper'>
            <img src={Logo} alt='Bestpark Logo' />
            <div className='content'>
              <p className='title white'>
                {park !== undefined ? park.name : ''}
              </p>
              <p className='sub-title white'>
                {park !== undefined ? park.tagline : ''}
              </p>
            </div>
          </div>
          <div className='content'>
            <p className='days white'>
              {t(
                'reservation.card.days',
                `${reservation.reservationDays.length}`,
              )}
            </p>
            <div className='calendar'>
              {sortedDates.map((item, index) => {
                return <DateBox key={index} date={new Date(item)} />;
              })}
            </div>
          </div>
        </div>
        <span className='card-btn btn button primary with-next-icon'>
          <a onClick={buttonAction} href={href}>
            <span>{buttonText}</span>
          </a>
        </span>
      </div>
    </div>
  );
};

export default ReservationCard;
